import HTMLReactParser from 'html-react-parser';
import { marked } from 'marked';
import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../../components/Button';

/**
 * @param HTMLString string to be parsed
 * @param stringFormat Storyblok might return a string in markdown format,
 * in that case we can set `stringFormat` as `markdown` to parse markdown to
 * html string.
 */
export const parseHTML = (
    HTMLString: string,
    stringFormat: 'html' | 'markdown' = 'html',
) => {
    return HTMLReactParser(
        stringFormat === 'markdown' ? marked(HTMLString) : HTMLString,
        {
            replace: ({ attribs, name }: any) => {
                /**
                 * Allows to render <Link> component if parsed markdown will
                 * contain `<Link to="/reset" label="klikk her" />`
                 */
                if (name === 'link') {
                    return <Link to={attribs.to}>{attribs.label}</Link>;
                }

                if (name === 'button') {
                    return <Button {...attribs}>{attribs.label}</Button>;
                }

                return null;
            },
        },
    );
};
